<template>
  <div>
    <v-data-table
      :headers="layoutSetting.headers"
      :items="current.tableData"
      hide-default-footer
    >
      <template v-slot:item="props">
        <tr>
          <td v-if="layoutSetting.section.isVerify">{{ props.index + 1 }}</td>
          <td v-for="(field, index) in layoutSetting.formFields" :key="index">
            <v-select
              v-if="field.controlType==='v-select'"
              v-model="props.item[field.fieldKey]"
              :items="field.options[field.fieldKey]"
              :label="field.label"
              single-line
              hide-details
              style="min-width: 200px"
              :disabled="isTableDisabled"
            ></v-select>
            <v-text-field
              v-else-if="field.controlType===undefined"
              v-model="props.item[field.fieldKey]"
              prefix="$"
              type="number"
              style="max-width: 105px"
              hide-details
              :disabled="isTableDisabled"
            ></v-text-field>
            <arb-date-picker-menu v-else v-model="props.item[field.fieldKey]" :label="field.label" :disabled="isTableDisabled" :allowed="field.allowed" :key="index + Math.floor(Math.random()*1000)"></arb-date-picker-menu>
          </td>
          <td v-if="layoutSetting.section.isVerify">
            <v-btn depressed outlined icon fab dark color="pink" small
                   v-if="setting.action === 'EDIT'"
                   @click="editItems('DELETE', props.item, props.index)"
                   :disabled="isTableDisabled"
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-btn v-if="layoutSetting.section.isVerify" class="add-btn" color="primary" text @click="editItems('ADD')" :disabled="isTableDisabled">Add</v-btn>
  </div>
</template>

<script>
import { DataType, Tool, Popup } from '@/util/index'
const TOOL = new Tool()
const popup = new Popup()
export default {
  name: 'section-table',
  props: {
    loan: Object,
    layoutSetting: Object,
    current: Object,
    setting: Object,
    isTableDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      assist: {
        tool: TOOL,
        dataType: DataType
      },
      dialog: {
        formDatePicker: false,
        tableDatePicker: [false],
        loading: false
      }
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  methods: {
    editItems (action, item, index) {
      const $this = this
      const tableData = $this.current.tableData
      const lastOne = $this.current.tableData.length - 1

      switch (action) {
        case 'ADD':
          if ($this.assist.tool.isNotEmpty(tableData)) {
            if ('id' in tableData[lastOne] && Object.keys(tableData[lastOne]).length === 7) {
              tableData.push({ loanId: $this.loanId })
            } else if (!('id' in tableData[lastOne]) && Object.keys(tableData[lastOne]).length === 6) {
              tableData.push({ loanId: $this.loanId })
            } else {
              popup.popupForWarning('fill it up')
            }
          } else {
            tableData.push({ loanId: $this.loanId })
          }
          $this.dialog.tableDatePicker.push(false)
          break
        case 'DELETE':
          if (tableData[index] === item) {
            // remove from table
            tableData.splice(index, 1)
          }
          break
        default:
          break
      }
    }
  }
}
</script>
<style scoped lang="scss">
.add-btn{
  margin-top: 26px;
  position: fixed;
  top: inherit;
}
</style>
